import { Input } from "@/components/ui/input"
import type { ComponentProps } from "react"
import type { UseFormReturn } from "react-hook-form"
import { Field } from "./Field"

type TextFieldProps = {
  form: UseFormReturn<any>
  name: string
  label?: string
  description?: string
  inputProps?: Omit<ComponentProps<typeof Input>, "value" | "onChange" | "onBlur" | "name">
}

export const TextField = ({
  form,
  name,
  label,
  description,
  inputProps
}: TextFieldProps) => {
  return (
    <Field
      form={form}
      name={name}
      label={label}
      description={description}
      render={field => <Input {...field} {...inputProps} />}
    />
  )
}
